import React, { useCallback, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import GenerationQueueList from './GenerationQueueList';
import AgentTimelinePanel from './AgentTimelinePanel';
import useCanvasActivity from '../../../hooks/useCanvasActivity';
import { canvasKeys } from '../../../api/canvasApi';

/**
 * RightPanelStack - Container that stacks GenerationQueue and AgentTimeline
 * Uses smart polling - only polls when there's active work
 * Automatically refreshes canvas when agent work completes
 */
const RightPanelStack = ({ canvasId, nodes }) => {
    const queryClient = useQueryClient();

    // Track refresh trigger for child components
    const [refreshKey, setRefreshKey] = useState(0);

    // Callback when all activities complete - refresh canvas data
    const handleActivityComplete = useCallback(() => {
        console.log('[RightPanelStack] Activity completed, refreshing canvas data');

        // Invalidate React Query cache to trigger refetch of nodes and media
        queryClient.invalidateQueries({ queryKey: canvasKeys.nodes(canvasId) });
        queryClient.invalidateQueries({ queryKey: canvasKeys.media(canvasId) });

        // Also trigger child component refresh
        setRefreshKey(prev => prev + 1);
    }, [canvasId, queryClient]);

    // Smart polling hook - only polls when there's active work on this canvas
    const { hasActiveWork, activities } = useCanvasActivity(canvasId, handleActivityComplete);

    return (
        <div style={{
            position: 'absolute',
            top: 15,
            right: 20,
            display: 'flex',
            flexDirection: 'column',
            gap: 12,
            zIndex: 1000,
            maxHeight: 'calc(100vh - 100px)',
            pointerEvents: 'none'
        }}>
            {/* Generation Queue - Top */}
            <GenerationQueueList inline={true} />

            {/* Agent Timeline - Below */}
            <AgentTimelinePanel
                canvasId={canvasId}
                nodes={nodes}
                inline={true}
                refreshKey={refreshKey}
                hasActiveWork={hasActiveWork}
                activities={activities}
            />
        </div>
    );
};

export default RightPanelStack;

